/* eslint-disable no-console */
import { AuthenticationResult } from '@azure/msal-common'
import Utils from './Utils'
import Cookie from 'universal-cookie'

export function setAccessTokenLocalStorageAndCookie({
  accessToken,
  account
}: AuthenticationResult) {
  const cookies = new Cookie()
  const isLocalhost = Utils.isLocalhost()
  cookies.set('access_token', accessToken, {
    path: '/',
    domain: isLocalhost ? '.localhost' : '.valeglobal.net',
    secure: true,
    sameSite: isLocalhost ? 'none' : 'lax'
  })
  cookies.update()
  localStorage.setItem('ACCESS_TOKEN', accessToken)
  localStorage.setItem('user-id', account?.localAccountId ?? '')
}
